module.exports = __webpack_public_path__ + "static/media/product_5_BU1420.9fb7ae94.jpg";